<template>
  <div style="transition: 0.4s; box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6); z-index: 9999;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 66 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep !== 66"
        @click="closeTips()"
      >
        {{useText}}
      </button>
      <button
        :style="{ opacity: nowStep === 58 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep !== 58"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 66"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="switchToOtherStep()"
      >
        {{switchToOtherStepText}}
      </button>
      <button
        v-else-if="nowStep === 74"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/advertisingMaterialTips.json';

export default {
  name: 'AdvertisingMaterialTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      useText: '不用了',
      nextText: '下一步',
      switchToOtherStepText: '是的',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.useText = '不用了';
          this.nextText = '下一步';
          this.switchToOtherStepText = '是的';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.useText = 'No';
          this.nextText = 'next';
          this.switchToOtherStepText = 'yes';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    switchToOtherStep() {
      this.$emit('switchToOtherStep');
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">
/*無效？*/
.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 9999;
}

.step58 {
  position: absolute;
  top: 50vh;
  left: 20vw;
}

.step5801 {
  position: absolute;
  top: 50vh;
  left: 20vw;
}

.step59 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.step60 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.step61 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.step62 {
  position: absolute;
  top: 40vh;
  left: 35vw;
}

.step63 {
  position: absolute;
  top: 55vh;
  left: 30vw;
}

.step64 {
  position: absolute;
  top: 55vh;
  left: 30vw;
}

.step65 {
  position: absolute;
  top: 65vh;
  left: 50vw;
}

.step66 {
  position: absolute;
  top: 65vh;
  left: 50vw;
}

.step67 {
  position: absolute;
  top: 60vh;
  left: 40vw;
}

.step68 {
  position: absolute;
  top: 65vh;
  left: 40vw;
}

.step69 {
  position: absolute;
  top: 65vh;
  left: 40vw;
}

.step70 {
  position: absolute;
  top: 50vh;
  left: 20vw;
}

.step71 {
  position: absolute;
  top: 30vh;
  left: 45vw;
}

.step72 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.step73 {
  position: absolute;
  top: 50vh;
  left: 20vw;
}

.step74 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.step75 {
  position: absolute;
  top: 40vh;
  left: 20vw;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
